// Exports
export default {
	"responsiveHeight": "responsiveHeight_ZKLdF",
	"important": "important_emFM+"
};
